import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Eye, Edit2, Trash2, Loader2, Building2, User } from 'lucide-react';
import { STATI, getStatoStyle } from './constants';

const PraticaRow = ({ p, isAdmin, onDetail, onEdit, onDelete, onChangeStato }) => {
  const statoStyle = getStatoStyle(p.stato);
  const beneficiario = (p.beneficiario_provvigione || '').toLowerCase() || ((p.segnalato_da || '').trim() ? 'collaboratore' : 'agenzia');
  const beneficiarioNome = p.beneficiario_nome || (beneficiario === 'agenzia' ? 'Agenzia' : (p.segnalato_da || 'Collaboratore'));
  return (
    <tr className="hover:bg-slate-50/50 transition-colors" data-testid={`pratica-${p.id}`}>
      <td className="px-4 py-3">
        <button onClick={() => onDetail(p)} className="text-left hover:text-amber-700 transition-colors">
          <p className="font-semibold text-slate-800">{p.nome_cliente} {p.cognome_cliente}</p>
          {p.codice_fiscale && <p className="text-xs text-slate-400 font-mono">{p.codice_fiscale}</p>}
        </button>
      </td>
      <td className="px-3 py-3"><Badge variant="outline" className="text-[10px]">{p.tipo}</Badge></td>
      <td className="px-3 py-3 text-slate-600 text-xs">{p.compagnia || '-'}</td>
      <td className="px-3 py-3 text-right font-mono text-xs">{p.importo_erogato ? `${Number(p.importo_erogato).toLocaleString('it-IT')} EUR` : '-'}</td>
      <td className="px-3 py-3">
        <select value={p.stato} onChange={e => onChangeStato(p, e.target.value)}
          className={`text-[10px] px-2 py-1 rounded-full font-medium border-0 cursor-pointer ${statoStyle.color}`} data-testid={`stato-${p.id}`}>
          {STATI.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </td>
      <td className="px-3 py-3 text-xs text-slate-500">{p.segnalato_da || '-'}</td>
      {isAdmin && (
        <td className="px-3 py-3">
          <span className={`text-[10px] font-semibold px-2 py-1 rounded-full inline-flex items-center gap-1 ${beneficiario === 'agenzia' ? 'bg-amber-100 text-amber-700' : 'bg-sky-100 text-sky-700'}`} data-testid={`beneficiario-${p.id}`}>
            {beneficiario === 'agenzia' ? <Building2 size={10} /> : <User size={10} />}
            {beneficiarioNome}
          </span>
        </td>
      )}
      {isAdmin && <td className="px-3 py-3 text-right font-mono text-xs font-semibold text-green-700">{p.provvigione_importo ? `${Number(p.provvigione_importo).toLocaleString('it-IT')} EUR` : '-'}</td>}
      <td className="px-3 py-3">
        <div className="flex gap-0.5">
          <button onClick={() => onDetail(p)} className="p-1.5 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-slate-700" data-testid={`view-${p.id}`}><Eye size={14} /></button>
          <button onClick={() => onEdit(p)} className="p-1.5 hover:bg-blue-50 rounded-lg text-slate-400 hover:text-blue-600" data-testid={`edit-${p.id}`}><Edit2 size={14} /></button>
          <button onClick={() => onDelete(p.id)} className="p-1.5 hover:bg-red-50 rounded-lg text-slate-400 hover:text-red-500"><Trash2 size={14} /></button>
        </div>
      </td>
    </tr>
  );
};

export const PraticheTable = ({ pratiche, loading, isAdmin, onDetail, onEdit, onDelete, onChangeStato }) => (
  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            <th className="text-left px-4 py-3 font-semibold text-slate-600 text-xs uppercase">Cliente</th>
            <th className="text-left px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Tipo</th>
            <th className="text-left px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Compagnia</th>
            <th className="text-right px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Importo</th>
            <th className="text-left px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Stato</th>
            <th className="text-left px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Segnalatore</th>
            {isAdmin && <th className="text-left px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Beneficiario</th>}
            {isAdmin && <th className="text-right px-3 py-3 font-semibold text-slate-600 text-xs uppercase">Provvigione</th>}
            <th className="px-3 py-3"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {loading ? (
            <tr><td colSpan="9" className="text-center py-12"><Loader2 className="animate-spin mx-auto text-slate-400" size={20} /></td></tr>
          ) : pratiche.length === 0 ? (
            <tr><td colSpan="9" className="text-center py-12 text-slate-400">Nessuna pratica trovata</td></tr>
          ) : pratiche.map(p => (
            <PraticaRow key={p.id} p={p} isAdmin={isAdmin} onDetail={onDetail} onEdit={onEdit} onDelete={onDelete} onChangeStato={onChangeStato} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
